import type { AppConfig } from "../../types/appConfig";
import type { PortalCustomer, PortalToken } from "./Auth.typed";
import { assertResponseOk, fetchZekay } from "../zekay/httpClient";

export class AuthModel {
  zekayAPI: string;

  constructor(config: AppConfig) {
    this.zekayAPI = config.zekayAPI;
  }

  async loginPortal(customer: PortalCustomer, companyId?: string): Promise<PortalToken> {
    const qs = companyId ? `?companyId=${companyId}` : "";
    const response = await fetchZekay(this.zekayAPI + "/portal/v2/login" + qs, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(customer),
    });
    await assertResponseOk(response);

    return (await response.json()) as PortalToken;
  }
}
